const AllCandidateDatabase = () => import("./views/AllCandidateDatabase.vue");
const ViewCandidateInformation = () =>
  import("./views/ViewCandidateInformation.vue");
const AllInterviewList = () => import("./views/AllInterviewList.vue");
const AllHiredCandidate = () => import("./views/AllHiredCandidate.vue");
const CreateProfile = () => import("./views/CreateProfile.vue");
const ViewHiredCandidateProfile = () =>
  import("./views/ViewHiredCandidateProfile.vue");
const RedirectToGetId = () => import("./views/RedirectToGetId.vue");

export default [
  {
    path: "candidate-database/:id",
    component: AllCandidateDatabase,
  },
  {
    path: "candidate-database/view/:id",
    component: ViewCandidateInformation,
  },
  {
    path: "interview-list/:id",
    component: AllInterviewList,
  },
  {
    path: "hired-candidate/:id",
    component: AllHiredCandidate,
  },
  {
    path: "hired-candidate/create-profile",
    component: CreateProfile,
  },
  {
    path: "hired-candidate/view/:id",
    component: ViewHiredCandidateProfile,
  },
  {
    path: "hired-candidate/edit/:id",
    component: CreateProfile,
  },
  {
    path: "candidate-database",
    component: RedirectToGetId,
  },
  {
    path: "interview-list",
    component: RedirectToGetId,
  },
  {
    path: "hired-candidate",
    component: RedirectToGetId,
  },
];
